export default __webpack_public_path__ + "static/mobile-popup-32ecbfdf7e7830378ce255f9df2e402a.jpg";